<template>
  <el-form :model="form" :rules="rules" ref="formPrivacyPolicy">
    <el-form-item prop="hasAcceptedGdpr">
      <el-checkbox v-model="form.hasAcceptedGdpr">
        <span v-html="data.data"></span>
      </el-checkbox>
    </el-form-item>

    <el-form-item class="text-right m-b-0">
      <el-button type="text" @click="onCancel" class="m-r-1">{{ $t('Cancel') }}</el-button>
      <el-button type="primary" @click="onSubmitForm('formPrivacyPolicy')" v-loading="loading">{{ $t('Accept') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { LOGOUT } from '@/router/route-types';

export default {
  name: 'FormPrivacyPolicy',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        hasAcceptedGdpr: null
      },
      loading: false,
      rules: {
        hasAcceptedGdpr: [{ required: true, message: this.$t('Please fill out mandatory fields'), trigger: 'change' }]
      }
    };
  },

  methods: {
    acceptPrivacyPolicy() {
      this.loading = true;

      this.$store
        .dispatch('SET_PRIVACYPOLICY', { policyAccepted: this.form.hasAcceptedGdpr })
        .then(response => {
          this.loading = false;
          if (!response.data.hasError) {
            this.onClose();

            this.$message({
              type: 'success',
              message: this.$t('Thank you'),
              duration: 7000,
              showClose: true
            });
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },

    onCancel() {
      this.onClose();
      this.$router.push({ name: LOGOUT });
    },

    onClose() {
      this.$store.commit('dialog/CLOSE_DIALOG');
    },

    onSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.form.hasAcceptedGdpr) {
          this.acceptPrivacyPolicy();
        } else {
          this.form.hasAcceptedGdpr = null;
          return false;
        }
      });
    }
  }
};
</script>
